import { useMutation } from 'react-query';

import { confidentialProject } from 'shared/api/projects/http';

const useMutateConfidentialProject = (options = undefined) => useMutation((id) => confidentialProject(id), options);

export default useMutateConfidentialProject;
